import { useNavigate } from "react-router-dom";
import { HandySvg } from "handy-svg";
import ArrowIcon from "./icon/Vector.svg";
import "./StyleButtonBack.css";
import Reload from "../ReloadBut/Reload";

function ButtonBack({ funck, hasUnsavedChanges, onConfirmExit, onConfirmReload }) {
    let navigate = useNavigate();

    const handleClick = async () => {
        if (funck) {
            funck();
            return;
        }

        if (hasUnsavedChanges && onConfirmExit) {
            const confirmed = await onConfirmExit();
            if (confirmed) {
                navigate(-1);
            }
        } else {
            navigate(-1);
        }
    };

    return (
        <div className="button__container max--width--control">
            <div className="button__wrapper" onClick={handleClick}>
                <HandySvg src={ArrowIcon} className="button__wrapper__icon" />
            </div>
            <Reload
                hasUnsavedChanges={hasUnsavedChanges}
                onConfirmReload={onConfirmReload}
            />
        </div>
    );
}

export default ButtonBack;